import { createContext } from 'react';
import type { AxiosRequestConfig } from 'axios';

export interface ErrorContextType {
  errorInfo: {
    retryAction?: () => Promise<void>;
    retryUrl?: string;
    previousUrl?: string;
    errorType?: 'network' | 'server' | 'timeout' | 'bad-gateway';
    statusCode?: number;
    message?: string;
    requestConfig?: AxiosRequestConfig;
  } | null;
  setError: (errorInfo: ErrorContextType['errorInfo']) => void;
  clearError: () => void;
  retryLastRequest: () => Promise<void>;
}

export const ErrorContext = createContext<ErrorContextType | undefined>(undefined);
